import { useList, useDetail, useCreate, useUpdate, useDelete } from "@inmagik/react-crud"
import { Copia } from "../types"
import { API_URL } from "../constants"

export function useCopieList(params: Record<string, string> = {}) {
  return useList<Copia>(`${API_URL}/copie`, {
    query: params,
  })
}

export function useCopia(id: number | undefined | string) {
  return useDetail<Copia>(`${API_URL}/copie`, id?.toString())
}

export function useCopiaCreate() {
  return useCreate<Copia>(`${API_URL}/copie`)
}

export function useCopiaUpdate() {
  return useUpdate<Copia>(`${API_URL}/copie`)
}

export function useCopiaDelete() {
  return useDelete<Copia>(`${API_URL}/copie`)
}